import { render, staticRenderFns } from "./ChoosePlanet.vue?vue&type=template&id=344fce78&scoped=true"
import script from "./ChoosePlanet.vue?vue&type=script&lang=js"
export * from "./ChoosePlanet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344fce78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('344fce78')) {
      api.createRecord('344fce78', component.options)
    } else {
      api.reload('344fce78', component.options)
    }
    module.hot.accept("./ChoosePlanet.vue?vue&type=template&id=344fce78&scoped=true", function () {
      api.rerender('344fce78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ChoosePlanet.vue"
export default component.exports